<template>
    <span>
        <span v-for="(errorKey, index) in errors" :key="index">
            <span v-for="(error, errorIndex) in errorKey" :key="errorIndex">
                {{ error }}
                <br>
            </span>
        </span>
    </span>
</template>

<script>
    export default {
        props: {
            errors: {
                default: []
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ErrorList.vue?3b3c1312